/**
 * Перемещение курсора в конец поля
 * @param element - поле, в котором требуется осуществить перемещение курсора
 */
export const setFocusAtEnd = (element: HTMLTextAreaElement | HTMLElement) => {
    if (element instanceof HTMLTextAreaElement) {
        const length = element.value.length;

        element.focus();
        element.setSelectionRange(length, length);
    } else if (element instanceof HTMLElement) {
        const selection = typeof window === 'undefined' ? null : window.getSelection();

        if (!selection) {
            return;
        }

        const emptyNode = document.createTextNode('');
        element.appendChild(emptyNode);

        const range = document.createRange();
        range.setStartBefore(emptyNode);
        range.collapse(true);
        selection.removeAllRanges();
        selection.addRange(range);

        element.removeChild(emptyNode);
    }
};
